import { render, staticRenderFns } from "./Fileupload.vue?vue&type=template&id=21182a80&scoped=true&"
import script from "./Fileupload.vue?vue&type=script&lang=js&"
export * from "./Fileupload.vue?vue&type=script&lang=js&"
import style0 from "./Fileupload.vue?vue&type=style&index=0&id=21182a80&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21182a80",
  null
  
)

export default component.exports